export const getBatchIndex = (renderIndex: number, batchEndIndices: readonly number[]): number => {
	let start = 0;
	let end = batchEndIndices.length;
	while (start < end) {
		const middle = Math.floor((start + end) / 2);
		if (renderIndex < batchEndIndices[middle]) {
			end = middle;
		} else {
			start = middle + 1;
		}
	}
	return start;
};
